export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/whiteboard_animated_explainers.0a52aa4.svg";